<template>
    <div
            class="money el-input"
            :class="{'is-disabled':disabled,'el-input-group el-input-group--append':!!$slots.append}">
        <div class="el-input el-input--suffix">
            <input
                    ref="ipt"
                    autocomplete="off"
                    type="text"
                    rows="2"
                    :disabled="disabled"
                    :style="style"
                    validateevent="true"
                    class="el-input__inner"
                    v-model="val">
            <span class="el-input__suffix" v-show="showClose">
      <span class="el-input__suffix-inner">
      <i class="el-input__icon el-icon-circle-close el-input__clear" @click="clear"></i>
      </span>
    </span>
        </div>
        <div
                v-if="!!$slots.append"
                class="el-input-group__append">
            <slot name="append"></slot>
        </div>
    </div>
</template>
<script>
  import appUtil from '@/mixins/appUtil'
    function numToMoney (v, n) {
        const fixed = this.fixed || 2
        let r
        const ipt = this.$refs['ipt']
        if (v === '' || v === undefined) {
            return v
        } else {
            let [a, b = ''] = (v + '').split(/(?=\.)/)
            let x = a.length % 3
            r = a.substr(0, x) +
                a.substr(x).replace(/(\d{3})/g, ',$1').substr(+!x)
            if (n) r += (+(0 + b)).toFixed(n).substr(1)
            else if (b) r += b.substr(0, fixed + 1)
        }
        if (ipt) {
            let st = -1
            if (document.activeElement === ipt) {
                const val = ipt.value + ''
                if (val === '' || /^\.0*$/g.test(val)) {
                    this.$emit('input', '')
                    this.$emit('change', '')
                    return ''
                }
            }
            ipt.value = r
            if (st !== -1) ipt.setSelectionRange(st, st)
        }
        return r
    }
    export default {
      mixins: [appUtil],
        data () {
            return {
                showClose: false,
                style: 'font-size:150%;'
            }
        },
        props: {
            value: {
                required: false,
                'default': ''
            },
            disabled: {
                type: Boolean,
                required: false,
                'default': false
            },
            fixed: {
                type: Number,
                required: false
            },
            max: {
                type: Number,
                required: false
            },
            min: {
                type: Number,
                required: false
            },
            clearable: {
                type: Boolean,
                required: false,
                'default': false
            }
        },
        methods: {
            clear () {
                const { ipt } = this.$refs
                ipt.focus()
                ipt.value = ''
                this.$emit('input', '')
                this.$emit('change', '')
            }
        },
        computed: {
            val: {
                get () {
                    return numToMoney.call(this, this.value, this.fixed)
                },
                set (v) {
                    const { fixed = 2, value, max = Number.MAX_SAFE_INTEGER } = this
                    v = this.zenhan(v)
                    const fix1 = v.replace(/[^0-9,.]/g, '')
                    const fix2 = v.replace(/,/g, '')
                    const fix3 = parseFloat(Math.min(parseFloat(fix2), max).toFixed(fixed))
                    const nan = isNaN(fix3)
                    if (fix1 !== v || nan || value === fix3) {
                        numToMoney.call(this, value, fixed)
                    } else if (!nan) {
                        this.$emit('input', fix3)
                        this.$emit('change', fix3)
                    }
                }
            }
        }
    }
</script>
